import { z } from "zod";

export const webhookFormSchema = z
    .object({
        active: z.boolean(),
        title: z.string(),
        subtitle: z.string(),
        wait: z.boolean(),
        timeout: z.number().nullable(),
        token: z.string().min(1, "components.connection-creator.nodes.webhook.forms.token_required"),
    })
    .superRefine((val, ctx) => {
        if (val.wait) {
            if (val.timeout === null) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["timeout"],
                    message: "components.connection-creator.nodes.webhook.forms.timeout_required",
                });
            } else if (val.timeout > 40) {
                ctx.addIssue({
                    code: z.ZodIssueCode.too_big,
                    maximum: 40,
                    type: "number",
                    inclusive: true,
                    path: ["timeout"],
                    message: "components.connection-creator.nodes.webhook.forms.timeout_max",
                });
            }
        }
    });

export type WebhookFormData = z.infer<typeof webhookFormSchema>;
